import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getStripCustomer = async (params) => {
    try {
  return await get<ApiResponse<[]>>(`/stripepayments/customer?${params}`).then((res)=> {
    if(res?.success===true) {
        return res;
    }
    else {
        return null
    }
  })
}
catch(e) {
    HandleApiError(e)
}
};
